export default "__VITE_ASSET__D00ffez6__"